module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.490fa183.ttf";